import { TrashIcon } from '@grupoboticario/flora-react-icons';
import { ButtonGhost, List, Picture, Item } from 'ui/components/primitives';
import { QuantitySelector } from 'ui/components/templates/QuantitySelector';
import { ItemsStyles } from './Items.styles';
import type { ItemsProps } from './Items.d';
import type { UIEvent } from 'react';

const ItemsBase = ({ items = [], onAmountChange, onDelete, onKeepShopping }: ItemsProps) => {
  const handleItemDelete = (event: UIEvent<HTMLButtonElement>) => {
    const { code } = event.currentTarget.dataset || {};

    if (code) {
      onDelete(code);
    }
  };

  return (
    <ItemsStyles.Component data-testid="item-list">
      <List
        footer={
          <ButtonGhost onClick={onKeepShopping} stretch>
            Adicionar mais produtos
          </ButtonGhost>
        }
      >
        {items.map(
          ({
            image = {},
            isCustomCombo,
            name,
            priceTotal,
            productCode,
            productOrigin,
            productPosition,
            quantity,
            itemListName,
          }) => (
            <Item key={productCode}>
              <ItemsStyles.Content>
                <ItemsStyles.Image>
                  <Picture
                    alt={image.title}
                    ratio="4x3"
                    sources={[
                      {
                        srcSet: `${image.url}`,
                      },
                    ]}
                    src={image.url}
                  />
                </ItemsStyles.Image>
                <ItemsStyles.Details>
                  <ItemsStyles.Title>
                    <small>{productCode}</small>
                    <span>{name}</span>
                  </ItemsStyles.Title>

                  <ItemsStyles.ButtonDelete
                    aria-label="delete button"
                    data-testid="delete-button"
                    data-code={productCode}
                    onClick={handleItemDelete}
                    size="small"
                  >
                    <TrashIcon size={12} />
                  </ItemsStyles.ButtonDelete>
                  <ItemsStyles.Total>
                    <small>{quantity === 1 ? 'Total item' : 'Total itens'}</small>
                    <span>{priceTotal}</span>
                  </ItemsStyles.Total>
                  <ItemsStyles.QuantitySelector>
                    <QuantitySelector
                      isCombo={isCustomCombo}
                      onChange={(amount) =>
                        onAmountChange({
                          productCode,
                          productPosition,
                          productOrigin,
                          quantity: amount,
                          itemListName,
                        })
                      }
                      productCode={productCode}
                      value={quantity}
                    />
                  </ItemsStyles.QuantitySelector>
                </ItemsStyles.Details>
              </ItemsStyles.Content>
            </Item>
          ),
        )}
      </List>
    </ItemsStyles.Component>
  );
};

export default ItemsBase;
